import React from "react";

export default class ResultBody extends React.Component {
    constructor(props) {
        super(props);
        this.googleFontsFound = props.result.hasOwnProperty('google_fonts_found') && props.result.google_fonts_found === true;
        this.otherToolsFound = props.result.hasOwnProperty('other_tools_found') && props.result.other_tools_found === true;
    }

    render() {
        return (
            <div aria-label='Resultate Body' className='scanner-body'>
                <div className="md:container mx-auto xl:max-w-7xl">
                    <div className="container-inner">
                        <div className="flex flex-col sm:grid sm:grid-cols-12 sm:gap-8 py-8 relative w-full scanResultsContainer">
                            <div title="Keine Probleme gefunden"
                                 className="col-span-2 sm:col-span-1 md:col-span-3 lg:col-span-2 flex flex-col items-center flex-shrink-0 cols">
{/*
                                <div aria-label='Ergebnisse Geladen' className='flex flex-col items-center mt-0 mb-4 sm:mt-3 sm:mb-0'>
                                    <Icon
                                        type={getResultIcon(this.props.result)}
                                        css='scanner-result--section-icon'
                                    />
                                    <small
                                        className='sm:hidden md:inline-block mt-1 text-center'><strong>{this.props.result.google_fonts_found ? 'Kritisches Problem gefunden' : 'Keine Probleme gefunden'}</strong></small>
                                </div>
*/}
                            </div>
                            <div
                                className="col-span-10 sm:col-span-10 md:col-span-8 lg:col-span-9 xl:col-span-8 flex-shrink mr-auto canHaveSectionItemError scanner-result--text">
                                {(this.googleFontsFound) && (
                                    <>
                                        <p className="text-xl md:mt-1">
                                            <strong>Google Fonts ist nicht DSGVO-konform eingebunden</strong>
                                        </p>
                                        <p className="scanner-result--sub-headline">
                                            <strong>Sie sind abmahngefährdet.</strong>
                                        </p>
                                        <p className="mb-4">
                                            Die von Ihnen ausgesuchte Schriftart wird bei jedem Aufruf Ihrer Website
                                            von den Google-Servern geladen.
                                            Es wird eine Verbindung zu den Servern aufgebaut, sodass die Schriftart
                                            dargestellt werden kann.
                                            Dabei wird während des Verbindungsaufbaus zu den Google-Servern die
                                            IP-Adresse des Websitebesuchers an Google in die USA übertragen.
                                            Die Schriftart wird also nicht lokal eingebunden (Remote Nutzung).
                                        </p>
                                        <p className="mb-4">
                                            Das Landgericht München I (LG München I, Az. 3 O 17493/20) hat Anfang 2022
                                            entschieden, dass die dynamische Einbindung von Google Fonts einen Verstoß
                                            gegen das Recht auf informationelle Selbstbestimmung darstellt.
                                            Aufgrund dieses Urteils gibt es sehr viele Abmahnungen von
                                            Websitebetreibern wegen fehlerhafter Google-Fonts-Einbindung.
                                        </p>
                                        <p className="mb-8">
                                            <strong>Besucher Ihrer Website können wegen der fehlerhaften Einbindung
                                                Schadensersatzansprüche gegen Sie geltend machen.</strong>
                                        </p>
                                        <p className="text-center">
                                            <a href="https://www.e-recht24.de/artikel/datenschutz/13052-datenschutz-und-google-fonts.html#ea-praxis-1"
                                               className={`button`}>
                                                Jetzt Google Fonts DSGVO-konform einbinden
                                            </a>
                                        </p>
                                    </>
                                )}

                                {(!this.googleFontsFound && this.otherToolsFound) && (
                                    <>
                                        <p className="text-xl md:mt-1">
                                            <strong>Ihre Website ist abmahngefährdet</strong>
                                        </p>
                                        <p className="scanner-result--sub-headline mb-4">
                                            <strong>Ihre Website enthält Tools, die Google Fonts laden.</strong>
                                        </p>
                                        <p className="mb-4">
                                            <p className="mb-4">
                                                Auf Ihrer Website werden zwar keine Schriftarten direkt von
                                                Google-Servern eingebunden, aber es wird dennoch eine Datenverbindung zu
                                                Google-Servern aufgebaut und die IP-Adresse des Websitebesuchers an
                                                Google übertragen.
                                                Dies geschieht, weil Sie in Ihre Website ein Tool eingebunden haben,
                                                welches Google Schriftarten verwendet.
                                                Dabei handelt es sich um Tools wie beispielsweise reCAPTCHA, Google
                                                Maps, Google Adsense, YouTube und Weitere.
                                                Wenn auf Ihrer Website beispielsweise Google Maps eine Google Schriftart
                                                lädt, wäre dies nicht problematisch, wenn Sie für Google Maps eine
                                                Einwilligung der Nutzer einholen würden.
                                                Unsere Prüfung konnte jedoch keinen Cookie Consent finden, der ein Laden
                                                des Tools vor einer Einwilligung verhindert.
                                            </p>
                                            <p className="mb-4">
                                                Die im betreffenden Tool eingebundene Schriftart wird bei jedem Aufruf
                                                Ihrer Website von den Google-Servern geladen.
                                                Es wird eine Verbindung zu den Servern aufgebaut, sodass die Schriftart
                                                dargestellt werden kann.
                                                Dabei wird während des Verbindungsaufbaus zu den Google-Servern die
                                                IP-Adresse des Websitebesuchers an Google übertragen.
                                                Die Schriftart wird also nicht lokal eingebunden (Remote Nutzung).</p>
                                            <p className="mb-4">Das Landgericht München I (LG München I, Az. 3 O
                                                17493/20) hat Anfang 2022 entschieden, dass die dynamische Einbindung
                                                von Google Fonts einen Verstoß gegen das Recht auf informationelle
                                                Selbstbestimmung darstellt.
                                                Aufgrund dieses Urteils gibt es sehr viele Abmahnungen von
                                                Websitebetreibern wegen fehlerhafter Google-Fonts-Einbindung.
                                            </p>
                                            <p className="mb-8">
                                                <strong>Besucher Ihrer Website können wegen der fehlerhaften Einbindung
                                                    Schadensersatzansprüche gegen Sie geltend machen.</strong>
                                            </p>
                                        </p>

                                        <div className="text-center">
                                            <a href="https://www.e-recht24.de/artikel/datenschutz/13052-datenschutz-und-google-fonts.html#ea-praxis-1" className={`button mb-4`}>
                                                JETZT GOOGLE FONTS DSGVO-KONFORM EINBINDEN
                                            </a>

                                            <a href={`https://www.e-recht24.de/mitglieder/lp-cookieeinwilligung/`} className={`button`}>
                                                JETZT COOKIE CONSENT BANNER EINBINDEN
                                            </a>
                                        </div>
                                    </>
                                )}

                                {(!this.googleFontsFound && !this.otherToolsFound) && (
                                    <>
                                        <p className="text-xl md:mt-1">
                                            <strong>Google Fonts ist korrekt eingebunden oder nicht vorhanden</strong>
                                        </p>
                                        <p className="scanner-result--sub-headline mb-4">
                                            Auf der von Ihnen eingegebenen Seite werden keine Google Fonts aus externen Quellen geladen.
                                        </p>
                                        <p className="mb-8">
                                            Hinweis: Andere Unterseiten Ihrer Website wurden nicht geprüft.
                                            Es ist möglich, dass dort Google Fonts zum Einsatz kommen.
                                            <br /><br />
                                            <strong>
                                                DSGVO-Verstöße können auch durch die Nutzung zahlreicher anderer Online-Tools entstehen.
                                                Prüfen Sie Ihre Website jetzt anonym und kostenlos mit dem eRecht24 DSGVO Website Scanner.
                                            </strong>
                                        </p>

                                        <p className="text-center">
                                            <a href={`https://www.e-recht24.de/websitescanner?u=` + window.btoa(this.props.url) + `&autostart=1`} className={`button`}>
                                                Jetzt vollständig prüfen
                                            </a>
                                        </p>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
